import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { format } from 'date-fns';

import type { Profile } from '@entities/agent-contract';

import { DateFormat } from '@shared/index';

import type { ProfilePersonalData } from '../model';
import { getGenderLabels } from '../utils';

export const useGetPersonalData = (profile?: Profile) => {
  const { t } = useTranslation();
  const genderLabels = getGenderLabels(t);
  const { lastName, firstName, middleName, rgsCode, gender, birthDate } =
    profile || {};
  const {
    numberPassport,
    seriesPassport,
    codeDepartment,
    nameDepartment,
    dateIssue,
    snils,
    inn,
  } = profile?.personalDocument || {};

  return useMemo<ProfilePersonalData>(
    () => ({
      fio:
        lastName || firstName || middleName
          ? `${lastName} ${firstName} ${middleName || ''}`
          : undefined,
      rgsCode,
      gender: gender ? genderLabels[gender] : undefined,
      birthDate: birthDate
        ? format(new Date(birthDate), DateFormat.DD_MM_YYYY)
        : undefined,
      passportSeriesNumber: numberPassport
        ? `${seriesPassport} ${numberPassport}`
        : undefined,
      codeDepartment,
      nameDepartment,
      dateIssue: dateIssue
        ? format(new Date(dateIssue), DateFormat.DD_MM_YYYY)
        : undefined,
      snils,
      inn,
    }),
    [
      firstName,
      lastName,
      middleName,
      rgsCode,
      gender,
      birthDate,
      numberPassport,
      seriesPassport,
      codeDepartment,
      nameDepartment,
      dateIssue,
      snils,
      inn,
    ]
  );
};
